import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { CasinoBannersState } from './CasinoBanners.state';
import { CasinoBannersNav } from './CasinoBannersNav';
import { CasinoBannersForm } from './CasinoBannersForm/CasinoBannersForm';
import { CasinoBannersList } from './CasinoBannersList/CasinoBannersList';
import {
    ColumnOneOfTwo,
    MainContent,
    TwoColumnResponsiveContentReverse,
} from 'src/domains/layouts/shared/layout/Layout.style';
import { useAppStateContext } from 'src/AppState/AppState';

export const CasinoBanners = observer('CasinoBanners', () => {
    const { session } = useAppStateContext();
    const [casinoBannersState] = useState(() => new CasinoBannersState(session));

    return (
        <MainContent>
            <CasinoBannersNav casinoBannersState={casinoBannersState} />
            {casinoBannersState.collection === 'casino' && (
                <TwoColumnResponsiveContentReverse>
                    <ColumnOneOfTwo>
                        <CasinoBannersList casinoBannersData={casinoBannersState.casinoBannersData} />
                    </ColumnOneOfTwo>

                    <ColumnOneOfTwo>
                        <CasinoBannersForm casinoBannersData={casinoBannersState.casinoBannersData} />
                    </ColumnOneOfTwo>
                </TwoColumnResponsiveContentReverse>
            )}
            {casinoBannersState.collection === 'live-casino' && (
                <TwoColumnResponsiveContentReverse>
                    <ColumnOneOfTwo>
                        <CasinoBannersList casinoBannersData={casinoBannersState.casinoBannersData} />
                    </ColumnOneOfTwo>

                    <ColumnOneOfTwo>
                        <CasinoBannersForm casinoBannersData={casinoBannersState.casinoBannersData} />
                    </ColumnOneOfTwo>
                </TwoColumnResponsiveContentReverse>
            )}
        </MainContent>
    );
});
